import { render, staticRenderFns } from "./Acessar.vue?vue&type=template&id=42514b24&scoped=true&"
import script from "./Acessar.vue?vue&type=script&lang=js&"
export * from "./Acessar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42514b24",
  null
  
)

export default component.exports